import { render, staticRenderFns } from "./BulkUploadCSV.vue?vue&type=template&id=37f4b995"
import script from "./BulkUploadCSV.vue?vue&type=script&lang=js"
export * from "./BulkUploadCSV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports